import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=be9a15e0&scoped=true"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=be9a15e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9a15e0",
  null
  
)

export default component.exports